import Modal from '../../general/Modal';
import { Container, Title, Footer, DivIcon, Content, SubTitle } from './styles';
import Button from '../../general/Button';
import Close from '../../../assets/icons/Close';
import { usePromiseTracker } from 'react-promise-tracker';
import ReactLoading from 'react-loading';

export const ConfirmActivedTaskModal = ({
  onConfirm = () => console.log('activate'),
  name,
  flow,
  isOpen,
  onClose,
  selector = '#root',
  className = null,
}) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'activate-task' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Ativação de Fluxo</Title>
        <SubTitle>Deseja seguir com a confirmação da tarefa?</SubTitle>
        {!promiseInProgress ? (
          <>
            <Content>{name}</Content>
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                greenBase
                content="Confirmar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onConfirm}
              />
            </Footer>
            <DivIcon>
              <Close onClick={onClose} />
            </DivIcon>
          </>
        ) : (
          <div
            style={{
              padding: '4rem',
              display: 'flex',
              alignItems: 'center',
              marginTop: '1rem',
            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>
        )}
      </Container>
    </Modal>
  );
};
